

// import React, { useState } from "react";
// import axios from "axios";
// import "./InquiryForm.css";

// const InquiryForm = ({ title = "Inquire Now" }) => {
//   const [formData, setFormData] = useState({
//     name: "",
//     email: "",
//     phone: "",
//     comments: "",
//   });

//   const [otp, setOtp] = useState("");
//   const [otpSent, setOtpSent] = useState(false);
//   const [otpVerified, setOtpVerified] = useState(false);
//   const [otpStatus, setOtpStatus] = useState("");
//   const [sendingOtp, setSendingOtp] = useState(false);
//   const [verifyingOtp, setVerifyingOtp] = useState(false);

//   const [status, setStatus] = useState("");
//   const [errors, setErrors] = useState({});
//   const [isSubmitting, setIsSubmitting] = useState(false);

//   const API_BASE = "https://trustyoudoctor.com"; // adjust if needed

//   const validate = () => {
//     const newErrors = {};
//     if (!formData.name.trim()) newErrors.name = "Name is required";
//     if (!formData.email.trim()) {
//       newErrors.email = "Email is required";
//     } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
//       newErrors.email = "Email is invalid";
//     }
//     if (!formData.phone.trim()) {
//       newErrors.phone = "Phone number is required";
//     } else if (!/^[6-9]\d{9}$/.test(formData.phone)) {
//       newErrors.phone = "Enter a valid 10-digit Indian mobile number";
//     }
//     if (!formData.comments.trim()) newErrors.comments = "Comments are required";

//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//     setErrors({ ...errors, [e.target.name]: "" });
//     setStatus("");

//     // Reset OTP verification if phone number changes after verification
//     if (e.target.name === "phone" && otpVerified) {
//       setOtpVerified(false);
//       setOtpSent(false);
//       setOtp("");
//       setOtpStatus("");
//     }
//   };

//   const handleSendOtp = async () => {
//     if (!formData.phone.trim() || !/^[6-9]\d{9}$/.test(formData.phone)) {
//       setErrors({ ...errors, phone: "Enter a valid 10-digit Indian mobile number" });
//       return;
//     }

//     setSendingOtp(true);
//     setOtpStatus("");

//     try {
//       const data = new FormData();
//       data.append("phone", formData.phone);

//       const response = await axios.post(`${API_BASE}/send_otp.php`, data, {
//         withCredentials: true,
//       });

//       if (response.data.success) {
//         setOtpSent(true);
//         setOtpStatus("✅ OTP sent to your phone");
//       } else {
//         setOtpStatus("❌ " + (response.data.message || "Failed to send OTP"));
//       }
//     } catch (error) {
//       console.error("Error sending OTP:", error);
//       setOtpStatus("⚠️ Something went wrong while sending OTP");
//     } finally {
//       setSendingOtp(false);
//     }
//   };

//   const handleVerifyOtp = async () => {
//     if (!otp.trim()) {
//       setOtpStatus("❌ Please enter the OTP");
//       return;
//     }

//     setVerifyingOtp(true);
//     setOtpStatus("");

//     try {
//       const data = new FormData();
//       data.append("otp", otp);

//       const response = await axios.post(`${API_BASE}/verify_otp.php`, data, {
//         withCredentials: true,
//       });

//       if (response.data.success) {
//         setOtpVerified(true);
//         setOtpStatus("✅ Phone number verified");
//       } else {
//         setOtpStatus("❌ " + (response.data.message || "Incorrect OTP"));
//       }
//     } catch (error) {
//       console.error("Error verifying OTP:", error);
//       setOtpStatus("⚠️ Something went wrong while verifying OTP");
//     } finally {
//       setVerifyingOtp(false);
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!validate()) return;

//     if (!otpVerified) {
//       setStatus("❌ Please verify your phone number before submitting.");
//       return;
//     }

//     setIsSubmitting(true);
//     setStatus("Sending...");

//     try {
//       const data = new FormData();
//       data.append("name", formData.name);
//       data.append("email", formData.email);
//       data.append("phone", formData.phone);
//       data.append("comments", formData.comments);

//       const response = await axios.post(`${API_BASE}/send_mail.php`, data);

//       if (response.data.success) {
//         setStatus("✅ Inquiry sent successfully!");
//         setFormData({ name: "", email: "", phone: "", comments: "" });
//         setOtp("");
//         setOtpSent(false);
//         setOtpVerified(false);
//         setOtpStatus("");
//       } else {
//         setStatus("❌ Failed to send. Please try again.");
//       }
//     } catch (error) {
//       console.error("Error sending inquiry:", error);
//       setStatus("⚠️ Something went wrong. Please try again later.");
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   return (
//     <section className="inquiry-section">
//       <h2>{title}</h2>
//       <form className="inquiry-form" onSubmit={handleSubmit} noValidate>
//         <div className="form-group">
//           <label>Name</label>
//           <input
//             type="text"
//             name="name"
//             value={formData.name}
//             onChange={handleChange}
//             placeholder="Enter your full name"
//           />
//           {errors.name && <span className="error-message">{errors.name}</span>}
//         </div>

//         <div className="form-group">
//           <label>Email</label>
//           <input
//             type="email"
//             name="email"
//             value={formData.email}
//             onChange={handleChange}
//             placeholder="Enter your email"
//           />
//           {errors.email && <span className="error-message">{errors.email}</span>}
//         </div>

//         <div className="form-group">
//           <label>Phone Number</label>
//           <div style={{ display: "flex", gap: "8px" }}>
//             <input
//               type="tel"
//               name="phone"
//               value={formData.phone}
//               onChange={handleChange}
//               placeholder="10-digit mobile number"
//               disabled={otpVerified}
//               style={{ flex: 1 }}
//             />
//             <button
//               type="button"
//               onClick={handleSendOtp}
//               disabled={sendingOtp || otpVerified}
//               className="send-btn"
//               style={{ whiteSpace: "nowrap" }}
//             >
//               {otpVerified ? "Verified ✅" : sendingOtp ? "Sending..." : otpSent ? "Resend OTP" : "Send OTP"}
//             </button>
//           </div>
//           {errors.phone && <span className="error-message">{errors.phone}</span>}
//         </div>

//         {otpSent && !otpVerified && (
//           <div className="form-group">
//             <label>Enter OTP</label>
//             <div style={{ display: "flex", gap: "8px" }}>
//               <input
//                 type="text"
//                 value={otp}
//                 onChange={(e) => setOtp(e.target.value)}
//                 placeholder="6-digit OTP"
//                 maxLength={6}
//                 style={{ flex: 1 }}
//               />
//               <button
//                 type="button"
//                 onClick={handleVerifyOtp}
//                 disabled={verifyingOtp}
//                 className="send-btn"
//               >
//                 {verifyingOtp ? "Verifying..." : "Verify"}
//               </button>
//             </div>
//           </div>
//         )}

//         {otpStatus && <p className="status-message">{otpStatus}</p>}

//         <div className="form-group">
//           <label>Comments</label>
//           <textarea
//             name="comments"
//             rows="4"
//             value={formData.comments}
//             onChange={handleChange}
//             placeholder="Enter your message"
//           />
//           {errors.comments && <span className="error-message">{errors.comments}</span>}
//         </div>

//         <p className="contact-number">
//           📞 Call Us: <strong style={{ color: "red" }}>+91 9922514719</strong>
//         </p>

//         <button type="submit" className="send-btn" disabled={isSubmitting || !otpVerified}>
//           {isSubmitting ? "Sending..." : "Send Inquiry"}
//         </button>
//       </form>

//       {status && <p className="status-message">{status}</p>}
//     </section>
//   );
// };

// export default InquiryForm;



import React, { useState } from "react";
import axios from "axios";
import "./InquiryForm.css";

const InquiryForm = ({ title = "Inquire Now" }) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    comments: "",
  });

  const [otp, setOtp] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [otpVerified, setOtpVerified] = useState(false);
  const [otpStatus, setOtpStatus] = useState("");
  const [sendingOtp, setSendingOtp] = useState(false);
  const [verifyingOtp, setVerifyingOtp] = useState(false);

  const [status, setStatus] = useState("");
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const API_BASE = "https://www.trustyoudoctor.com"; // adjust if needed

  const validate = () => {
    const newErrors = {};
    if (!formData.name.trim()) newErrors.name = "Name is required";
    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Email is invalid";
    }
    if (!formData.phone.trim()) {
      newErrors.phone = "Phone number is required";
    } else if (!/^[6-9]\d{9}$/.test(formData.phone)) {
      newErrors.phone = "Enter a valid 10-digit Indian mobile number";
    }
    if (!formData.comments.trim()) newErrors.comments = "Comments are required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" });
    setStatus("");

    // Reset OTP verification if phone number changes after verification
    if (e.target.name === "phone" && otpVerified) {
      setOtpVerified(false);
      setOtpSent(false);
      setOtp("");
      setOtpStatus("");
    }
  };

  const handleSendOtp = async () => {
    if (!formData.phone.trim() || !/^[6-9]\d{9}$/.test(formData.phone)) {
      setErrors({ ...errors, phone: "Enter a valid 10-digit Indian mobile number" });
      return;
    }

    setSendingOtp(true);
    setOtpStatus("");

    try {
      const data = new FormData();
      data.append("phone", formData.phone);

      const response = await axios.post(`${API_BASE}/send_otp.php`, data, {
        withCredentials: true,
      });

      if (response.data.success) {
        setOtpSent(true);
        setOtpStatus("✅ OTP sent to your phone");
      } else {
        setOtpStatus("❌ " + (response.data.message || "Failed to send OTP"));
      }
    } catch (error) {
      console.error("Error sending OTP:", error);
      setOtpStatus("⚠️ Something went wrong while sending OTP");
    } finally {
      setSendingOtp(false);
    }
  };

  const handleVerifyOtp = async () => {
    if (!otp.trim()) {
      setOtpStatus("❌ Please enter the OTP");
      return;
    }

    setVerifyingOtp(true);
    setOtpStatus("");

    try {
      const data = new FormData();
      data.append("otp", otp);

      const response = await axios.post(`${API_BASE}/verify_otp.php`, data, {
        withCredentials: true,
      });

      if (response.data.success) {
        setOtpVerified(true);
        setOtpStatus("✅ Phone number verified");
      } else {
        setOtpStatus("❌ " + (response.data.message || "Incorrect OTP"));
      }
    } catch (error) {
      console.error("Error verifying OTP:", error);
      setOtpStatus("⚠️ Something went wrong while verifying OTP");
    } finally {
      setVerifyingOtp(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) return;

    if (!otpVerified) {
      setStatus("❌ Please verify your phone number before submitting.");
      return;
    }

    setIsSubmitting(true);
    setStatus("Sending...");

    try {
      const data = new FormData();
      data.append("name", formData.name);
      data.append("email", formData.email);
      data.append("phone", formData.phone);
      data.append("comments", formData.comments);

      const response = await axios.post(`${API_BASE}/send_mail.php`, data);

      if (response.data.success) {
        setStatus("✅ Inquiry sent successfully!");
        setFormData({ name: "", email: "", phone: "", comments: "" });
        setOtp("");
        setOtpSent(false);
        setOtpVerified(false);
        setOtpStatus("");
      } else {
        setStatus("❌ Failed to send. Please try again.");
      }
    } catch (error) {
      console.error("Error sending inquiry:", error);
      setStatus("⚠️ Something went wrong. Please try again later.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="inquiry-section">
      <h2>{title}</h2>
      <form className="inquiry-form" onSubmit={handleSubmit} noValidate>
        <div className="form-group">
          <label>Name</label>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder="Enter your full name"
          />
          {errors.name && <span className="error-message">{errors.name}</span>}
        </div>

        <div className="form-group">
          <label>Email</label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="Enter your email"
          />
          {errors.email && <span className="error-message">{errors.email}</span>}
        </div>

        <div className="form-group">
          <label>Phone Number</label>
          <div style={{ display: "flex", gap: "8px" }}>
            <input
              type="tel"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              placeholder="10-digit mobile number"
              disabled={otpVerified}
              style={{ flex: 1 }}
            />
            <button
              type="button"
              onClick={handleSendOtp}
              disabled={sendingOtp || otpVerified}
              className="send-btn"
              style={{ whiteSpace: "nowrap" }}
            >
              {otpVerified ? "Verified ✅" : sendingOtp ? "Sending..." : otpSent ? "Resend OTP" : "Send OTP"}
            </button>
          </div>
          {errors.phone && <span className="error-message">{errors.phone}</span>}
        </div>

        {otpSent && !otpVerified && (
          <div className="form-group">
            <label>Enter OTP</label>
            <div style={{ display: "flex", gap: "8px" }}>
              <input
                type="text"
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
                placeholder="6-digit OTP"
                maxLength={6}
                style={{ flex: 1 }}
              />
              <button
                type="button"
                onClick={handleVerifyOtp}
                disabled={verifyingOtp}
                className="send-btn"
              >
                {verifyingOtp ? "Verifying..." : "Verify"}
              </button>
            </div>
          </div>
        )}

        {otpStatus && <p className="status-message">{otpStatus}</p>}

        <div className="form-group">
          <label>Comments</label>
          <textarea
            name="comments"
            rows="4"
            value={formData.comments}
            onChange={handleChange}
            placeholder="Enter your message"
          />
          {errors.comments && <span className="error-message">{errors.comments}</span>}
        </div>

        <p className="contact-number">
          📞 Call Us: <strong style={{ color: "red" }}>+91 9922514719</strong>
        </p>

        <button type="submit" className="send-btn" disabled={isSubmitting || !otpVerified}>
          {isSubmitting ? "Sending..." : "Send Inquiry"}
        </button>
      </form>

      {status && <p className="status-message">{status}</p>}
    </section>
  );
};

export default InquiryForm;